import { RequestStatusBadge } from "@/components/common/section-components/badge/RequestStatusBadge";
import { LegalOnboardingStatus } from "@/constants/entity-status";
import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";

interface Props {
  detail: any;
}

export const DetailInfoCard = ({ detail }: Props) => {
  return (
    <Flex
      flexDir="column"
      padding="12px"
      border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      borderRadius="12px"
    >
      <Text
        className="amd-card-title"
        paddingBottom="10px"
        textTransform="uppercase"
        paddingX="24px"
        fontWeight={700}
      >
        Detalle
      </Text>

      <Grid templateColumns="repeat(2, 1fr)">
        <GridItem paddingX="24px" paddingY="10px">
          <Text className="account-title-label">CUIT/CUIL:</Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="10px">
          <Text className="account-value-label">{detail?.cuitCuil ?? "-"}</Text>
        </GridItem>

        <GridItem
          paddingX="24px"
          paddingY="10px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-title-label">Tipo de sociedad:</Text>
        </GridItem>
        <GridItem
          paddingX="24px"
          paddingY="10px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-value-label">
            {detail?.tipoSociedad ?? "-"}
          </Text>
        </GridItem>

        <GridItem paddingX="24px" paddingY="10px">
          <Text className="account-title-label">Estado:</Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="10px">
          <RequestStatusBadge
            status={detail?.estado as unknown as LegalOnboardingStatus}
            noPaddingY
          />
        </GridItem>
      </Grid>
    </Flex>
  );
};
